import ready, { HTML } from './utils';
import 'Plugins/responsiveHelper';
import initMobileNav from './components/mobileNav';
import initOpenClose from './components/openClose';
import initTabs from './components/tabset';
import initPopups from './components/popup';
import initLocations from './components/locations';
import initAccordion from './components/accordion';
import initSwiper from './components/swiper';
import initInViewport from './components/inViewport';

ready(() => {
  HTML.classList.add('is-loaded');
  initMobileNav();
  initOpenClose();
  initPopups();
  initLocations();
  initAccordion();
  initSwiper();
  initInViewport();
  initMap();
  initMultipleMaps();
  initTabs();
});

var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch;

window.addEventListener('load', () => {
  const rows = document.querySelectorAll(' .table-compare .swiper-wrapper > .col:first-child .cell');

  rows.forEach((cell, index) => {
    let maxHeight = 0;
    document.querySelectorAll(`.table-compare .swiper-wrapper > .col > .cell:nth-child(${index + 1})`).forEach(element => {
      maxHeight = Math.max(maxHeight, element.offsetHeight);
    });

    document.querySelectorAll(`.table-compare .swiper-wrapper > .col > .cell:nth-child(${index + 1})`).forEach(element => {
      element.style.height = `${maxHeight}px`;
    });
  });
});


const adjustCellHeights = () => {
  if (window.innerWidth <= 1024) {
    const rows = document.querySelectorAll('.table-compare .swiper-wrapper > .col:first-child .cell');

    rows.forEach((cell, index) => {
      let maxHeight = 0;
      document.querySelectorAll(`.table-compare .swiper-wrapper > .col > .cell:nth-child(${index + 1})`).forEach(element => {
        maxHeight = Math.max(maxHeight, element.offsetHeight);
      });

      document.querySelectorAll(`.table-compare .swiper-wrapper > .col > .cell:nth-child(${index + 1})`).forEach(element => {
        element.style.height = `${maxHeight}px`;
      });
    });
  } else {
    // Reset cell heights if window width is greater than 1024
    const cells = document.querySelectorAll('.table-compare .swiper-wrapper > .col > .cell');
    cells.forEach(cell => {
      cell.style.height = '';
    });
  }
};

// window.addEventListener('load', adjustCellHeights);
// window.addEventListener('resize', adjustCellHeights);

// Initialize and add the map
function initMap() {
    var mapElement = document.getElementById('map');
  if (!mapElement) {
    return; // Exit the function if the element doesn't exist
  }

  // Array of locations
  var locations = window.mapLocations || [];

  const center = window.mapLocations[0] || {lat: 34.7465, lng: -192.2896};
  // The map, centered on Arkansas
  var map = new google.maps.Map(document.getElementById('map'), {
    zoom: 9,
    center: center//,
    //styles: snazzyMapStyle
  });


  var svgIcon = {
    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#006444" d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>'
    ),
    scaledSize: new google.maps.Size(20, 26.5), // Adjust the size as needed
    anchor: new google.maps.Point(10, 26.5) // Adjust the anchor point as needed
};

    // Add markers to the map
  locations.forEach(function(location) {
    new google.maps.Marker({
      position: location,
      map: map,
            icon: svgIcon
    });
  });
}

// Example Snazzy Map style
var snazzyMapStyle = [
    {
        "featureType": "all",
        "elementType": "all",
        "stylers": [
            {
                "hue": "#ffaa00"
            },
            {
                "saturation": "-33"
            },
            {
                "lightness": "10"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9c5e18"
            }
        ]
    },
    {
        "featureType": "landscape.natural.terrain",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "saturation": "-23"
            },
            {
                "gamma": "2.01"
            },
            {
                "color": "#f2f6f6"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "saturation": "-14"
            }
        ]
    }
];

// multiples map init
function initMultipleMaps() {
  jQuery('.lender-item').createMarker({
    // addressArea: '.address-area',
		holderMap: '.map-holder',
		wrapMap: '.map-wrap',
		activeClass: 'active',
		overlay: '.overlay'
	});
}

/*
 * jQuery CreateMarker plugin
 */
;(function($) {
	function CreateMarker(options) {
		this.options = $.extend({
			holderMap: null,
			activeClass: 'active',
			overlay: '.overlay',
			mapOptions: {
				zoom: 14,
				scrollwheel: true,
				panControl: true,
				zoomControl: true,
				scaleControl: true,
				mapTypeControl: true,
				streetViewControl: true,
				draggable: isTouchDevice ? false : true//,
                //styles: snazzyMapStyle
			}
		}, options);

		this.init();
	}
	CreateMarker.prototype = {
		init: function() {
			this.findElements();
			this.makeCallback('onInit', this);
			this.createMap();
			this.attachEvents();
		},
		findElements: function() {
			this.holder = jQuery(this.options.holder);
			this.wrap = this.holder.find(this.options.holderMap);
			this.wrapMap = this.holder.find(this.options.wrapMap);
      this.coords = this.holder.data('coords');
      this.overlay = this.wrap.find(this.options.overlay);
			this.win = jQuery(window);

			this.openWindow = null;
		},
      createMap: function() {
			var self = this;
			this.map = new google.maps.Map(self.wrapMap[0], self.options.mapOptions);

      this.createMarkerIcon();
		},
		createMarkerIcon: function() {
			var self = this;

      if (!self.coords.lat || !self.coords.lang) return;

      self.latlng = new google.maps.LatLng(self.coords.lat, self.coords.lang);

      new google.maps.Marker({
        position: self.latlng,
        map: self.map
        // icon: markerItem.icon
      });

      self.map.setCenter(self.latlng);

      setTimeout(function() {
        self.overlay.fadeOut();
      }, 1000);
		},
		attachEvents: function() {
			var self = this;

			// flexible layout handler
			this.resizeHandler = function() {
				// self.wrapMap.css({
				// 	height: self.addressArea.outerHeight()
				// });
				self.map.setCenter(self.latlng);
			};

			this.resizeHandler();
			this.win.on('resize orientationchange', this.resizeHandler);
		},
		makeCallback: function(name) {
			if (typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		}
    };

	$.fn.createMarker = function(options) {
		return this.each(function() {
			$(this).data('CreateMarker', new CreateMarker($.extend(options, { holder:this })));
		});
	};
})(jQuery);
